import { render } from "./CapitalDetail.vue?vue&type=template&id=6bc0c206&scoped=true"
import script from "./CapitalDetail.vue?vue&type=script&lang=js"
export * from "./CapitalDetail.vue?vue&type=script&lang=js"

import "./CapitalDetail.vue?vue&type=style&index=0&id=6bc0c206&lang=less&scoped=true"

import exportComponent from "D:\\28\\前端\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bc0c206"]])

export default __exports__